export const AddProductAction = {
    SEARCH_FOR_NEW_PRODUCT_RESULT: "search_for_new_product_result",
    UPDATE_SEARCH_TEXT: "update_search_product",
    ADD_DELAR_PRODUCT_DTO: "add_delar_product_dto",
    DELETE_DELAR_PRODUCT_DTO: "delete_delar_product_dto",
    SAVE_DATA: "save_data",
}